module.exports = __webpack_public_path__ + "img/Boy_030011.6c549c71.png";